/* Accessibility preferences. Choices become classes on <html> and are kept in
   localStorage, so a returning visitor keeps their setting without an account. */
(function () {
  const KEY = 'ld:a11y';
  const TOGGLES = ['contrast', 'underline', 'motion'];

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; }
  };
  const write = (state) => {
    try { localStorage.setItem(KEY, JSON.stringify(state)); } catch (e) { /* private mode */ }
    apply(state);
  };

  const apply = (state) => {
    const root = document.documentElement;
    ['normal', 'large', 'larger'].forEach((s) => root.classList.toggle(`a11y-text-${s}`, state.text === s));
    TOGGLES.forEach((t) => root.classList.toggle(`a11y-${t}`, !!state[t]));
  };

  /* Apply before the panel exists so there is no flash of the default size. */
  apply(read());

  class Panel extends HTMLElement {
    connectedCallback() {
      this.sync();

      this.querySelectorAll('[data-a11y-close]').forEach((el) =>
        el.addEventListener('click', () => this.close())
      );
      this.querySelectorAll('[data-a11y-text]').forEach((btn) =>
        btn.addEventListener('click', () => {
          const state = read();
          state.text = btn.dataset.a11yText;
          write(state);
          this.sync();
        })
      );
      this.querySelectorAll('[data-a11y-toggle]').forEach((box) =>
        box.addEventListener('change', () => {
          const state = read();
          state[box.dataset.a11yToggle] = box.checked;
          write(state);
        })
      );
      this.querySelector('[data-a11y-reset]')?.addEventListener('click', () => {
        write({});
        this.sync();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && !this.hidden) this.close();
      });

      /* Any link pointing at the settings anchor opens this panel. */
      document.querySelectorAll('a[href="#accessibility-settings"]').forEach((link) =>
        link.addEventListener('click', (e) => {
          e.preventDefault();
          this.open(link);
        })
      );
    }

    sync() {
      const state = read();
      this.querySelectorAll('[data-a11y-text]').forEach((btn) =>
        btn.setAttribute('aria-pressed', btn.dataset.a11yText === (state.text || 'normal') ? 'true' : 'false')
      );
      TOGGLES.forEach((t) => {
        const box = this.querySelector(`[data-a11y-toggle="${t}"]`);
        if (box) box.checked = !!state[t];
      });
    }

    open(opener) {
      this.opener = opener;
      this.hidden = false;
      this.querySelector('.a11y__close')?.focus();
    }

    close() {
      this.hidden = true;
      this.opener?.focus();
    }
  }

  if (!customElements.get('accessibility-panel')) customElements.define('accessibility-panel', Panel);
})();
